import React from "react";

export default function FallbackView() {
  return <div>No results found, real sussy...</div>;
}
